import { ROLES } from "utils/helpers/enums/roles.enum";
import {
  EVENT_STATUS,
  GENDERS,
  SESSION_TYPES,
  SUBSCRIBER_STATUSES,
  USER_STATUSES,
} from "utils/helpers/enums/shared.enum";

export class UserFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  nameOrEmail: string = "";
  role: ROLES;
  city: string = "";
  status: USER_STATUSES;
  gender: GENDERS;
  searchTitle: string = "";
  hostName: string = "";
  name: string = "";
}

export class SubscribersFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  firstName: string = "";
  lastName: string = "";
  status: SUBSCRIBER_STATUSES;
}

export class ExperienceFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  nameOrEmail: string = "";
  role: ROLES;
  city: string = "";
  status: EVENT_STATUS = EVENT_STATUS.ALL;
  gender: GENDERS;
  searchTitle: string = "";
  isSession: string = "";
}

export class AllRequestFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  nameOrEmail: string = "";
  role: ROLES;
  city: string = "";
  gender: GENDERS;
  searchTitle: string = "";
  hostName: string = "";
  name: string = "";
  sessionType: SESSION_TYPES = SESSION_TYPES.ALL;
  rejectedRequest: boolean = false;
}

export class NotificationFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
}

export class BadgeFiltersDTO {
  page: number = 1;
  limit: number = 9;
  count: number = 1;
  size: number = 9;
  name: string = "";
  forRole: string = "";
}

export class CoreConceptFiltersDTO {
  page: number = 0;
  size: number = 100;
}


export class AmbassadorExperienceFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  searchTitle: string = "";
  nameOrEmail: string = "";
  eventType: string = "";
}